import { SurveyTemplate } from '@/surveys/state/types';

export const it = {
  assessments: {
    pageTitle: 'I miei assessment',
    page: {
      title: '{{templateName}} assessment',
    },
    surveyNotCompleted: {
      title: 'Completa l’assessment',
      steps: {
        title: 'Assessment da completare',
        description: {
          [SurveyTemplate.SoftSkillAssessment]:
            'Un questionario di 15 minuti progettato per misurare le soft skills chiave — come creatività, problem solving, collaborazione ed empatia — delle tua azienda e restituire un profilo personalizzato. I risultati ti permettono di conoscere i punti di forza, individuare aree di miglioramento e confrontarli con i trend aziendali.',
          [SurveyTemplate.HardSkillAssessment]:
            'Un questionario di 15 minuti pensato per misurare il livello di maturità nelle competenze tecniche generiche legate alla gestione dell’AI. I risultati ti permettono di conoscere i punti di forza, individuare aree di miglioramento e confrontarli con i trend aziendali.',
        },
        ctaLabel: 'Avvia assessment',
      },
      noSurvey: 'Nessun assessment da completare al momento.',
    },
    surveyResult: {
      title: 'Profile',
      description:
        "Il grafico riporta il tuo punteggio medio (scala 0-7) sulle {{metricsCount}} {{surveyTemplateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell'AI.",
      downloadAnswerGuide: 'Scarica Guida alle risposte',
      insightBox: {
        title: 'Insight',
        proTitle: 'Punti di forza',
        conTitle: 'Punti di debolezza',
      },
    },
    noResultVisible: {
      title: 'Assessment completato',
      description:
        "Hai completato l'assessment dedicato alla valutazione delle metriche dell'assessment {{surveyTemplateName}}. \nEsplora i contenuti disponibili e approfondisci le aree che pi\u00f9 ti interessano nella sezione Training.",
      buttonLabel: 'Esplora il training',
    },
    tutorial: {
      team: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Dai uno sguardo al tuo profilo',
            description:
              'Consulta il tuo profilo di hard skill e gli insight associati per comprendere i livelli raggiunti, individuare i tuoi punti di forza e le principali aree di miglioramento.',
          },
          slide2: {
            title: 'Confronta i risultati con il team e il dipartimento',
            description:
              'Analizza il confronto tra i tuoi punteggi, la media del team e del dipartimento per contestualizzare i risultati e capire dove sei allineato e dove puoi crescere.',
          },
        },
      },
      manager: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Dai uno sguardo al tuo profilo',
            description:
              'Consulta il tuo profilo di hard skill e gli insight associati per comprendere i livelli raggiunti, individuare i tuoi punti di forza e le principali aree di miglioramento.',
          },
          slide2: {
            title: 'Confronta i risultati con il team e il dipartimento',
            description:
              'Confronto tra il tuo punteggio con la media del tuo dipartimento e dell’intera organizzazione per contestualizzare i risultati e individuare aree di allineamento e opportunità di crescita.',
          },
        },
      },
      employee: {
        title: 'Assessment Tutorial',
        slides: {
          slide1: {
            title: 'Dai uno sguardo al tuo profilo',
            description:
              'Consulta il tuo profilo di hard skill e gli insight associati per comprendere i livelli raggiunti, individuare i tuoi punti di forza e le principali aree di miglioramento.',
          },
          slide2: {
            title: 'Confronta i risultati con il team',
            description:
              'Analizza il confronto tra i tuoi punteggi e la media del team per contestualizzare i risultati e capire dove sei allineato e dove puoi crescere.',
          },
        },
      },
    },
    resultsVsOrganization: {
      title: 'Come ti posizioni nella tua organizzazione?',
      description:
        'Confronto tra il tuo punteggio con la media del tuo dipartimento e dell\u2019intera organizzazione ',
      labelTooltipChart:
        'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento\n\n{{orgValue}} vs media organizzazione',
      legend: {
        yourScore: 'Personale',
        depAverage: 'Dipartimento {{depName}} ({{total}} persone)',
        orgAverage: 'Azienda ({{total}} persone)',
      },
      insightBox: {
        title: 'Insight',
      },
    },
    resultsVsDepartmentAndTeam: {
      title: 'Come ti posizioni nel tuo dipartimento?',
      description:
        'Confronto tra il tuo punteggio con la media del tuo team e del tuo dipartimento',
      labelTooltipChart:
        'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento\n\n{{teamValue}} vs media team',
      legend: {
        yourScore: 'Personale',
        depAverage: 'Dipartimento {{depName}} ({{total}} persone)',
        teamAverage: 'Team {{teamName}} ({{total}} persone)',
      },
      insightBox: {
        title: 'Insight',
      },
    },
    resultsVsTeam: {
      title: 'Come ti posizioni rispetto al tuo team?',
      description: 'Confronto tra il tuo punteggio e la media del tuo team',
      labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{teamValue}} vs media team',
      legend: {
        yourScore: 'Personale',
        teamAverage: 'Team {{teamName}} ({{total}} persone)',
      },
      insightBox: {
        title: 'Insight',
      },
    },
  },
};
